
// import axios from "axios";

// const API_BASE_URL = "http://127.0.0.1:8000/api";
// // const API_BASE_URL = "https://reqsys777.tapasyatech.in/api"

// export const requirementService = {
//   // NEW: Fetch active projects for the dropdown
//   // getProjects: async () => {
//   //   try {
//   //     const response = await axios.get(`${API_BASE_URL}/projects/`);
//   //     return response.data;
//   //   } catch (error) {
//   //     throw error.response ? error.response.data : new Error("Failed to fetch projects");
//   //   }
//   // },
  
// getProjects: async () => {
//     try {
//       // 1. Pull user_id from localStorage (handles both string and stringified object formats safely)
//       let userId = localStorage.getItem("user_id");
      
//       if (!userId) {
//         const userObj = localStorage.getItem("user");
//         if (userObj) {
//           const parsedUser = JSON.parse(userObj);
//           userId = parsedUser.user_id;
//         }
//       }

//       // 2. Pass user_id as a query string parameter
//       const response = await axios.get(`${API_BASE_URL}/projects/`, {
//         params: { user_id: userId }
//       });
      
//       return response.data;
//     } catch (error) {
//       throw error.response ? error.response.data : new Error("Failed to fetch projects");
//     }
//   },

// createProject: async (data) => {
//   const response =
//     await axios.post(
//       `${API_BASE_URL}/create-project/`,
//       data
//     );

//   return response.data;
// },
//   createRequirement: async (data) => {
//     try {
//       const response = await axios.post(`${API_BASE_URL}/create-requirement/`, data);
//       return response.data;
//     } catch (error) {
//       throw error.response ? error.response.data : new Error("Network Error");
//     }
//   },

// generateRequirementId: async (payload) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/generate-requirement-id/`, {
//         params: payload // Passes ?project=X&type=Y&category=Z&version=V
//       });
//       return response.data; 
//     } catch (error) {
//       throw error.response ? error.response.data : new Error("Failed to generate ID");
//     }
//   },

//   generateDocument: async (requirementId, format) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/generate-${format}/${requirementId}`, {
//         responseType: 'blob',
//       });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `Requirement_${requirementId}.${format}`);
//       document.body.appendChild(link);
//       link.click();
//     } catch (error) {
//       console.error("Download failed", error);
//     }
//   }
// };

// export const GetRequirements = {
//   getRequirements: async (projectId = null) => {
//     try {
//       // If a projectId is provided, append it as a query param
//       const url = projectId 
//         ? `${API_BASE_URL}/requirement-details/?project_id=${projectId}`
//         : `${API_BASE_URL}/requirement-details/`;

//       const response = await axios.get(url);
//       return response.data;
//     } catch (error) {
//       console.error("Error fetching requirements:", error);
//       throw error;
//     }
//   }
// };
// export const UpdateRequirement = {
//   updateRequirement: async (id, payload) => {
//     const response = await axios.post(
//       `${API_BASE_URL}/update-requirement/${id}/`,
//       payload
//     );
//     return response.data;
//   },
// };



// export const LoginService = {
//   login: async (payload) => {
//     try {
//       const response = await axios.post(`${API_BASE_URL}/login/`, payload);
//       return response.data;
//     } catch (error) {
//       throw error.response ? error.response.data : new Error("Network Error");
//     }
//   },

//   register: async (payload) => {
//     try {
//       const response = await axios.post(`${API_BASE_URL}/register/`, payload);
//       return response.data;
//     } catch (error) {
//       throw error.response ? error.response.data : new Error("Network Error");
//     }
//   },
// };



import axios from "axios";

// const API_BASE_URL = "http://127.0.0.1:8000/api";
const API_BASE_URL = "https://reqsys777.tapasyatech.in/api"

export const requirementService = {
  // Fetch active projects for the dropdown (Scoped to mapped user)
  getProjects: async () => {
    try {
      // 1. Pull user_id from localStorage (handles both string and stringified object formats safely)
      let userId = localStorage.getItem("user_id");
      
      if (!userId) {
        const userObj = localStorage.getItem("user");
        if (userObj) {
          const parsedUser = JSON.parse(userObj);
          userId = parsedUser.user_id;
        }
      }

      // 2. Pass user_id as a query string parameter
      const response = await axios.get(`${API_BASE_URL}/projects/`, {
        params: { user_id: userId }
      });
      
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Failed to fetch projects");
    }
  },

  createProject: async (data) => {
    const response = await axios.post(`${API_BASE_URL}/create-project/`, data);
    return response.data;
  },

  createRequirement: async (data) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/create-requirement/`, data);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Network Error");
    }
  },

  generateRequirementId: async (payload) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/generate-requirement-id/`, {
        params: payload // Passes ?project=X&type=Y&category=Z&version=V
      });
      return response.data; 
    } catch (error) {
      throw error.response ? error.response.data : new Error("Failed to generate ID");
    }
  },

  generateDocument: async (requirementId, format) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/generate-${format}/${requirementId}`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Requirement_${requirementId}.${format}`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Download failed", error);
    }
  },

  // =====================================================================
  // NEW: PROJECT MAPPING ADMINISTRATIVE FUNCTIONS
  // =====================================================================
  
  /**
   * Fetch all registered users to populate the mapping dropdowns/grids
   */
  getAllUsers: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/mapping/users/`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Failed to load users list.");
    }
  },

  /**
   * Fetch absolute list of all projects along with who has access to them
   */
  getAllMasterProjects: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/mapping/projects/`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Failed to load projects mapping data.");
    }
  },

  /**
   * Map a user profile to a specific project (Creates junction entry)
   */
  assignProject: async (userId, projectId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/mapping/assign/`, {
        user_id: userId,
        project_id: projectId,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Failed to map user to project.");
    }
  },

  /**
   * Revoke access and unassign a user from a project (Deletes junction entry)
   */
  unassignProject: async (userId, projectId) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/mapping/unassign/`, {
        user_id: userId,
        project_id: projectId,
      });
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Failed to remove user mapping.");
    }
  }
};

export const GetRequirements = {
  getRequirements: async (projectId = null) => {
    try {
      const url = projectId 
        ? `${API_BASE_URL}/requirement-details/?project_id=${projectId}`
        : `${API_BASE_URL}/requirement-details/`;

      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching requirements:", error);
      throw error;
    }
  }
};

export const UpdateRequirement = {
  updateRequirement: async (id, payload) => {
    const response = await axios.post(`${API_BASE_URL}/update-requirement/${id}/`, payload);
    return response.data;
  },
};

export const LoginService = {
  login: async (payload) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login/`, payload);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Network Error");
    }
  },

  register: async (payload) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/register/`, payload);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : new Error("Network Error");
    }
  },
};